// extracted by mini-css-extract-plugin
module.exports = {"header":"loginCommonStyle_header__39xy2"};